const POLICY_TRANSLATIONS_URL = 'https://www.flowjo.com/policy_translations';

const PolicyTranslationsLink = () => (
  <a href={POLICY_TRANSLATIONS_URL} target="_blank" rel="noreferrer">Policy Translations</a>
);

export default PolicyTranslationsLink;
